import React, { useEffect, JSX } from 'react';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import useWindowSize from '@hooks/use-window-size';
import { useTranslation } from 'next-i18next';
import { scrollToTop } from '@helpers/utils/general';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import useUser from '@hooks/user/use-user';
import { useAnalytics } from '@context/analytics/analytics.context';
import Button from '@components/atoms/button/button';
import styles from './seller-information-error.module.scss';

const SellerInformationError = (): JSX.Element => {
  const { isWiderThanMd } = useWindowSize();
  const { t } = useTranslation('get-paid');
  const { isAuthenticated } = useUser();
  const { sendAnalyticEvent: sendSellerInfoAnalyticEvents } = useAnalyticEvents('seller_info');
  const { scriptsEventData } = useAnalytics();

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    if (isAuthenticated && scriptsEventData?.isTcEvents1Loaded && scriptsEventData?.isTcEvents7Loaded) {
      sendSellerInfoAnalyticEvents('seller_tax_page', {
        label: 'error_page',
      });
    }
  }, [scriptsEventData?.isTcEvents1Loaded, scriptsEventData?.isTcEvents7Loaded, isAuthenticated]);

  return (
    <div className={styles.sellerInformationError}>
      <div className={styles.sellerInformationError__icon}>
        <Icon
          name="warning-large"
          ariaHidden
        />
      </div>
      <div className={clsx(styles.sellerInformationError__title, isWiderThanMd ? 'vc-heading-A32' : 'vc-heading-A24')}>
        {t('GET_PAID.TAX_INFORMATION_FORM.ERROR.TITLE', 'Error')}
      </div>
      <div className={clsx(styles.sellerInformationError__subtitle, 'vc-text-H16')}>
        {t('GET_PAID.TAX_INFORMATION_FORM.ERROR.SYSTEM_ERROR', 'Something went wrong. Please try reloading the page.')}
      </div>
      <Button
        className={clsx(styles.sellerInformationError__cta, 'vc-text-l')}
        variant="primary"
        size="large"
        onClick={() => {
          sendSellerInfoAnalyticEvents('seller_tax_error_reload');
          window.location.reload();
        }}
      >
        {t('GET_PAID.TAX_INFORMATION_FORM.RELOAD_CTA', 'Reload')}
      </Button>
    </div>
  );
};

export default SellerInformationError;
